import React from 'react';

import { withErrorBoundary } from '@justgiving/error-boundary';
import loadable from '@loadable/component';

import clientConfig from '../../client/config';
import { usePageMeta, usePageOwner } from '../../hooks';
import { useAuthenticateUser } from '../../hooks/useAuthenticateUser';
import componentDidCatch from '../../utils/componentDidCatch';
import ErrorPageWrapper from '../ErrorPage/ErrorPageWrapper';

const TeamsPage = loadable(() =>
  import(/* webpackChunkName: "TeamsPage" */ '../TeamsPage/TeamsPage'),
);
const CampaignPage = loadable(() =>
  import(/* webpackChunkName: "CampaignPage" */ '../CampaignPage/CampaignPage'),
);
const AuctionPage = loadable(() =>
  import(/* webpackChunkName: "AuctionPage" */ '../AuctionPage/AuctionPage'),
);
const FundraisingPage = loadable(() =>
  import(
    /* webpackChunkName: "FundraisingPage" */ '../FundraisingPage/FundraisingPage'
  ),
);
const InMemoryPage = loadable(() =>
  import(/* webpackChunkName: "InMemoryPage" */ '../InMemoryPage/InMemoryPage'),
);

export function PageType() {
  const {
    isPreview,
    currentUrl,
    pageType,
    error,
    pageShortName,
  } = usePageMeta();
  const { isUserLoggedIn } = useAuthenticateUser();
  const { isCheckingPageOwner, data } = usePageOwner();

  if (isPreview && !isUserLoggedIn) {
    window.location.assign(`${clientConfig.loginUrl}${encodeURI(currentUrl)}`);
    return null;
  }

  if (isPreview && !isCheckingPageOwner && !data?.legacyId) {
    return <ErrorPageWrapper status={404} messageKey={'page.error404'} />;
  }

  if (error) {
    return (
      <ErrorPageWrapper status={error.status} messageKey={error.messageKey} />
    );
  }

  if (isPreview && isCheckingPageOwner) {
    return null;
  }

  if (
    clientConfig.flags.enableOtgAuction &&
    pageShortName === 'otg-2020-auction'
  ) {
    return <AuctionPage />;
  }

  if (pageType === 'team') {
    return <TeamsPage />;
  }

  if (pageType === 'campaign') {
    return <CampaignPage />;
  }

  if (pageType === 'fundraising') {
    return <FundraisingPage />;
  }

  if (pageType === 'one_page') {
    return <FundraisingPage />;
  }

  if (pageType === 'in_memory') {
    return <InMemoryPage />;
  }

  return null;
}

export default withErrorBoundary(
  PageType,
  <ErrorPageWrapper />,
  componentDidCatch,
);
